
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-category-view',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop() readonly categoryId: number;
  @Prop() readonly catalogData: object;
  @Prop({default: 'CatalogCategory'}) readonly dataSource: string;
  @Prop({default: () => []}) readonly wishlistItems: Array<object>;

  private created(): void {
    this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, this.categoryId);
    this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, this.catalogData);

    window.onpopstate = ({state}) => {
      this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, null === state ? this.categoryId : state['categoryId']);
      this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, null === state ? this.catalogData : state['catalogData']);
    };

    history.replaceState({categoryId: this.categoryId, catalogData: this.catalogData}, document.title);
  }

  private mounted(): void {
    window.addEventListener('load', () => {
      const catalogCategoryProductPlaceholders = document.querySelector('.catalog__category-placeholder');
      if (catalogCategoryProductPlaceholders) {
        (catalogCategoryProductPlaceholders as HTMLElement).style.display = 'none';
      }
    });
  }
}
